// extracted by mini-css-extract-plugin
export default {"containerWarning":"styles_containerWarning__gZ1Po","container":"styles_container__WIiAn","title":"styles_title__hDhU0","text":"styles_text__y2Av1","img":"styles_img__q-wLz"};